import React from 'react'
import Router from "./router/Router"
import './App.css'
import ScrollToTop from "./component/scroll/ScrollToTop"
// import Navbar from "./component/navbar/Navbar.jsx"
function App() {
  return (
    <div>
      {/* <Navbar /> */}
      <Router />
      <ScrollToTop />
    </div>
  )
}

export default App
